import { render } from "./RegisterPhone.vue?vue&type=template&id=62294379"
import script from "./RegisterPhone.vue?vue&type=script&lang=js"
export * from "./RegisterPhone.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__